import { action, observable } from 'mobx'
import { Api } from 'utilities'
import { RootStore, GENERAL_STORE, PERSONS_TABLE_STORE } from 'store'
import { Person, PersonDTO } from 'models'
import { PERSON_PROJECTS_TABLE_STORE } from 'store/PersonProjectsTableStore'

export const PERSON_STORE = 'PERSON_STORE'

export class PersonStore {
  @observable personsList: Person[] = []
  @observable personToView: Person = {} as Person

  rootStore: RootStore;

  constructor (rootStore: RootStore) {
    this.rootStore = rootStore
  }

  @action.bound setPersonsList (list: Person[] = []) {
    this.personsList = list
  }

  @action.bound setPersonToView (person: Person = {} as Person) {
    this.personToView = person
  }

  getAll = (loadContents = false, loadProjects = false) => {
    const {
      setLoadingOn, setLoadingOff, handleApiError
    } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    Api
      .get(`/person/all?loadContents=${loadContents}&loadProjects=${loadProjects}`)
      .then((data: PersonDTO[]) => {
        const persons = data.map(p => new Person(p))
        this.setPersonsList(persons)

        const { setSearchResults, triggerSearch } = this.rootStore[PERSONS_TABLE_STORE]
        setSearchResults(persons)
        triggerSearch()

        setLoadingOff()
      })
      .catch(handleApiError)
  }

  createPerson = (personDetails: PersonDTO): Promise<void> => {
    const {
      setLoadingOn, push, showSuccess, handleApiError
    } = this.rootStore[GENERAL_STORE];
  
    setLoadingOn();
  
    return Api
      .post('/person/create', personDetails)
      .then(({ id }: PersonDTO) => {
        if (personDetails.relatedMedia.length) {
          return Api.post('/person/update', { id, ...personDetails });
        }
        return new Promise<void>((resolve) => resolve());  // Resolves with void
      })
      .then(() => {
        push('/persons');
        showSuccess('The new person is added to the list.');
      })
      .catch(handleApiError);
  }
  
  editPerson = (personDetails: PersonDTO) => {
    const {
      setLoadingOn, setLoadingOff, showSuccess, handleApiError
    } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    Api
      .post('/person/update', personDetails)
      .then((data: PersonDTO) => {
        this.getPersonById(data.id)
        this.setPersonsList()
        setLoadingOff()
        // push('/persons')
        showSuccess('Details have been saved.')
      })
      .catch(handleApiError)
  }

  getPersonById = (id: string | number) => {
    const {
      setLoadingOn, setLoadingOff, handleApiError
    } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    Api
      .get(`/person/${id}/view?loadContents=true&loadProjects=true`)
      .then((data: PersonDTO) => {
        const person = new Person(data)
        this.setPersonToView(person)
        const {
          setSearchResults,
          triggerSearch
        } = this.rootStore[PERSON_PROJECTS_TABLE_STORE]
        setSearchResults(person.projects)
        triggerSearch()
        setLoadingOff()
      })
      .catch(handleApiError)
  }
}
